import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { StartUpService } from './service/start-up.service';
import { LoadingScreenComponent } from '@DataFriends-Group/ngx-core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoadingScreenComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  public startUpSvc = inject(StartUpService);
}
